import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import _ from 'lodash';

import { ExternalCrmAccount } from 'src/models';
import { ApiService } from 'src/services/api.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-external-crm-account-selector-modal',
  templateUrl: './external-crm-account-selector-modal.component.html',
  styleUrls: ['./external-crm-account-selector-modal.component.css'],
})
export class ExternalCrmAccountSelectorModalComponent implements OnInit {
  @Input()
  public selectedExternalCrmAccount?: ExternalCrmAccount;

  @Input()
  public externalCrmType: string;

  @ViewChild('searchBar', { static: false }) searchBar;

  public selectedExternalCrmAccountId?: string;
  public externalCrmAccounts: ExternalCrmAccount[];
  public filteredExternalCrmAccounts: ExternalCrmAccount[];
  public isLoading: boolean;
  public isLoadingExternalCrmAccounts: boolean;
  public isOpen = true;
  public searchText: string;

  constructor(
    private modalCtrl: ModalController,
    private apiService: ApiService,
  ) {}

  async ngOnInit() {
    setTimeout(() => this.searchBar.setFocus(), 500);

    this.selectedExternalCrmAccountId = this.selectedExternalCrmAccount?.id;
    await this.loadExternalCrmAccounts();
  }

  async loadExternalCrmAccounts() {
    this.isLoadingExternalCrmAccounts = true;

    const options: any = {
      limit: 100,
      order: ['name'],
    };

    if (this.searchText) {
      options.where = [
        {
          field: 'name',
          operator: 'like',
          value: `%${this.searchText}%`,
        },
      ];
    }

    const externalCrmAccountsResult: any = await this.apiService.postPromise('/external-crm/accounts/list', options);

    this.externalCrmAccounts = externalCrmAccountsResult.data;
    this.isLoadingExternalCrmAccounts = false;
  }

  dismiss() {
    this.isOpen = false;
    this.modalCtrl.dismiss();
  }

  async selectExternalCrmAccount(channel: ExternalCrmAccount) {
    this.selectedExternalCrmAccountId = channel.id;
    this.selectedExternalCrmAccount = channel;

    this.isOpen = false;

    this.modalCtrl.dismiss({ externalCrmAccount: this.selectedExternalCrmAccount });
  }

  handleFilters() {
    this.loadExternalCrmAccounts();
  }
}
